import { render, staticRenderFns } from "./ScrollableContent.vue?vue&type=template&id=42a2234e"
import script from "./ScrollableContent.vue?vue&type=script&lang=js"
export * from "./ScrollableContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports